import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Shipment, ShipmentGroup } from '../../../../lib/shipment-group/shipment-group.service';
import { MultiselectOptionItem, QueryFieldModel } from '../../../../util/core-utils';
import { OrderType, QueryResult } from '../../../../lib/util/services';
import { ConfigModel } from '../../../../util/task-record-utils';
import { RightModel } from '../../../../app.rights';
import { TransportShipmentGroupModel, TransportShipmentModel } from '../../../shipment/shipment-group-list/shipment-group-list.component';
import { ConfigurationService } from '../../../../lib/configuration/configuration.service';
import { RightResolver, RightService } from '../../../../lib/right.service';
import { TranslateService } from '@ngx-translate/core';
import { Set } from 'immutable';
import { ShippingDemand } from '../../../../lib/shipping-demand/shipping-demand.service';
import { Address } from '../../../../lib/address';
import { ExteriorTransportService } from '../../../../lib/exterior-transport/exterior-transport.service';
import { ShipmentRightModel } from '../../../../app.rights.shpiment';
import { UserService } from '../../../../lib/user.service';
import { ExteriorTransportRightModel } from '../../../../lib/exterior-transport/exterior-transport-right.model';
import ShipmentState = Shipment.ShipmentState;
import ShipmentGroupState = ShipmentGroup.ShipmentGroupState;

@Component({
  selector: 'app-exterior-transport-shipments',
  templateUrl: './exterior-transport-shipments.component.html',
  styleUrls: ['./exterior-transport-shipments.component.scss']
})
export class ExteriorTransportShipmentsComponent implements OnInit {

  ShipmentGroup = ShipmentGroup;
  pagingId = 'exteriorTransportShipmentList';

  @Input()
  exteriorTransportId: number;

  @Input()
  readonly: boolean;

  @Input()
  deletable: boolean;

  @Input()
  exteriorTransportRights: ExteriorTransportRightModel;

  @Output()
  shipmentRemove: EventEmitter<Shipment.Shipment> = new EventEmitter<Shipment.Shipment>();

  queryModel: QueryFieldModel<ShipmentGroup.OrderField> = new QueryFieldModel(ShipmentGroup.OrderField.ID, OrderType.DESC);

  config: ConfigModel = new ConfigModel();
  shipmentGroupStates: MultiselectOptionItem<ShipmentGroupState>[] = [];
  shipmentStates: MultiselectOptionItem<ShipmentState>[] = [];

  shipmentGroupList: TransportShipmentGroupModel[] = [];

  rightModel: RightModel = RightModel.empty();
  shipmentRightModel: ShipmentRightModel = ShipmentRightModel.empty();

  constructor(
    private configurationService: ConfigurationService,
    private exteriorTransportService: ExteriorTransportService,
    private rightService: RightService,
    private translateService: TranslateService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.loadRightModels();
    this.initComponent();
  }

  initComponent() {
    this.loadConfig(() => {
      this.loadStates(() => {
        this.loadList();
      });
    });
  }

  reloadComponent() {
    this.loadList();
  }

  private loadConfig(completion: () => void) {
    this.config = this.configurationService.getConfigurationModel();
    completion();
  }

  private loadRightModels() {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.userService.get({
          id: resolver.userProfile!.id
        }).subscribe((user) => {
          this.rightModel = RightModel.of(resolver);
          this.shipmentRightModel = ShipmentRightModel.of({
            rightModel: this.rightModel,
            currentCompanies: user.companies.map(c => c.id)
          });
        });

      }
    );
  }

  private loadStates(completion: () => void) {
    this.shipmentGroupStates = [];
    this.shipmentStates = [];
    ShipmentGroup.shipmentGroupStates.forEach(
      (state) => {
        const item = {
          id: state.state,
          itemName: state.stringKey
        };
        this.shipmentGroupStates.push(item);
      });
    this.shipmentGroupStates.forEach(
      (state: MultiselectOptionItem<ShipmentGroupState>) => {
        this.translateService.get(state.itemName).subscribe((stateName: string) => {
            state.itemName = stateName;
          }
        );
      });
    Shipment.shipmentStates.forEach(
      (state) => {
        const item = {
          id: state.state,
          itemName: state.stringKey
        };
        this.shipmentStates.push(item);
      });
    this.shipmentStates.forEach(
      (state: MultiselectOptionItem<ShipmentState>) => {
        this.translateService.get(state.itemName).subscribe((stateName: string) => {
            state.itemName = stateName;
          }
        );
      });
    completion();
  }

  private loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    const order = this.queryModel.getOrder();
    this.exteriorTransportService.getShipments({
      exteriorTransportId: this.exteriorTransportId,
      orders: Set.of(order),
      paging: requestedPage ? {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      } : undefined
    }).subscribe((result: QueryResult<ShipmentGroup.ShipmentGroup>) => {
      this.shipmentGroupList = [];
      result.items.forEach((sg: ShipmentGroup.ShipmentGroup) => {
        const group = new TransportShipmentGroupModel();
        group.id = sg.id;
        group.deliveryNoteNumber = sg.deliveryNote.number;
        group.customer = sg.demander ? sg.demander.company ? sg.demander.company.name : '' : '';
        group.sourceAddress = this.unwrapAddress(sg.source);
        group.destinationAddress = this.unwrapAddress(sg.destination);
        group.state = this.shipmentGroupStates.find(state => state.id === sg.state)!.itemName;
        group.stateObject = ShipmentGroup.shipmentGroupStates.find(state => state.state === sg.state)!
        sg.shipments.forEach((s: Shipment.Shipment) => {
          const shipment = new TransportShipmentModel();
          shipment.id = s.id;
          shipment.deliveryNoteNumber = s.deliveryNote.number;
          shipment.subTransporterName = s.subTransporter ? s.subTransporter.name : undefined;
          shipment.waybillNumber = s.transport ? s.transport.waybillNumber : '';
          shipment.trackingNumber = s.trackingNumber ? s.trackingNumber : '';
          shipment.customer = group.customer;
          shipment.sourceAddress = this.unwrapAddress(s.source);
          shipment.destinationAddress = this.unwrapAddress(s.destination);
          shipment.state = this.shipmentStates.find(state => state.id === s.state)!.itemName;
          shipment.stateObject = Shipment.shipmentStates.find(state => state.state === s.state)!;
          shipment.groupIsSafetyShipping = sg.safetyShipping;
          group.shipments.push(shipment);
        });
        this.shipmentGroupList.push(group);
      });
      this.queryModel.currentPage = requestedPage;
      this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
      this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
    });
  }

  unwrapAddress(shippingPlace: ShippingDemand.ShippingPlace): string {
    if (shippingPlace.place && shippingPlace.place.postalAddress) {
      return Address.PostalAddressMapper.toString(shippingPlace.place.postalAddress, this.config.postalAddressFormat);
    }
    else if (shippingPlace.location && shippingPlace.location.place && shippingPlace.location.place.postalAddress) {
      return Address.PostalAddressMapper.toString(shippingPlace.location.place.postalAddress, this.config.postalAddressFormat);
    }
    else {
      return '';
    }
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  orderBy(field: ShipmentGroup.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  removeShipment(shipment: Shipment.Shipment) {
    this.shipmentRemove.emit(shipment);
  }

  canEditGroup(shipmentGroup: TransportShipmentGroupModel) {
    return shipmentGroup.stateObject.state !== 'DELIVERED' && this.shipmentRightModel.shipmentGroupDemandRemove
        .hasRightForShipment({transporterId: shipmentGroup.transporterCompany.id}, undefined)
      || this.shipmentRightModel.shipmentGroupDepotUpdate
        .hasRightForShipment({transporterId: shipmentGroup.transporterCompany.id}, undefined);
  }


  onBatchDepotCreate() {
    // todo
  }

}
